import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { environment } from '../../../';
import { CookieNames, BasicRoutes, ApiEndpoints, ErrorText, Gtype, PaymentSteps } from '../../constant';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { ShoppingCartService, CustomObserverService, RegistrationFeeService, RegistrationFeeTokenService } from '../../../shared/';
import { LocalStorageService } from 'angular-2-local-storage';
import { DomSanitizer } from '@angular/platform-browser';

declare var $: any;

import {
  CookieManagerService,
  ErrorManagerService,
  HttpClientService,
  TimeService,
  // GoogleService,
  mobileNumberValidator,
  mobitelValidator,
  dialogValidator,
  cardExpireDate,
  cardNumber,
  lankaBellvalidator,
  cvv,
  emptyField,
  getCardType,
  dialogEtisalatHutchValidator,
} from '../../../shared/';
import { TranslateService } from '@ngx-translate/core';

import swal from 'sweetalert2';

import { NewUser } from '../../model/newUser';
import { CreditCard, PaperSet } from '../../model';

@Component({
  selector: 'app-payment',
  templateUrl: '../views/payment.component.html',
  styleUrls: ['../../../css/payment.component.css', '../../../css/paper-sets.component.css', '../../../css/login-selection.component.css'],
  // providers: [GoogleService]
})
export class PaymentComponent implements OnInit {
  @ViewChild('according') according: any;
  @Input('mobile-input') mobileInput: any;
  @Input() isRegistration: boolean = false;
  @Input() registrationFeeToken: string = null;

  public paymentId: string;
  public setid: string;
  public access_token: string = null;
  public paperSet: PaperSet;
  public paperSetDiscription: string;
  public user: NewUser = new NewUser({});
  public mobile: Array<any>;
  public selectEmail: string;
  public mobitelNumberList: Array<string> = [];
  public dialoglNumberList: Array<string> = [];
  public errorMessage: string;
  public apiRequstWaiter: boolean = true;
  public paymentType: Object = {};
  public pincode: string;
  public errorText: string;
  public createdBy: string;
  public card: any;
  public totalPrice: number = 0;
  public ItemsCheckout: Array<any>;
  public paperSets: Array<any> = [];
  public toBuyPaperSets: Array<any> = [];
  public userId: string;
  public toBuyCheckingArray: Array<any> = [];
  public toCheckingArray: Array<any> = [];
  public discountPrice: number = 0;

  public dialogBillFormValidator: FormGroup;
  public lankaBellFormValidator: FormGroup;
  public eZcashFormValidator: FormGroup;
  public mCashFormValidator: FormGroup;
  public sampathVisaFormValidator: FormGroup;
  public creditCard: CreditCard = new CreditCard();
  public price: string = '0';
  public removeItemId: number = 0;
  public lengthItems: number = 0;
  public isMobileRedirection: Boolean = false;

  public isValidpaymentCode: string = null;

  public imageProfile: any;

  public registrationFee: any;
  public registrationFeeAvailable: boolean = false;
  public redirectUrl: any;
  public isMobile: boolean = false;

  public paymentMethods = {
    'dialog': false,
    'm-cash': false,
    'ez-cash': false,
    'visa-master': false,
    'sampath-vishwa': false
  }

  paperPaymentUrl: string = BasicRoutes.clientPayment;

  constructor(private route: ActivatedRoute,
    private httpClientService: HttpClientService,
    private cookieManagerService: CookieManagerService,
    private ErrorManagerService: ErrorManagerService,
    private router: Router,
    private translateService: TranslateService,
    billDialogFn: FormBuilder,
    lankaBell: FormBuilder,
    eZcashFn: FormBuilder,
    mCashFn: FormBuilder,
    sampathVisaCashFn: FormBuilder,
    private shoppingCartService: ShoppingCartService,
    private customObserverService: CustomObserverService,
    private localStorageService: LocalStorageService,
    private registrationFeeService: RegistrationFeeService,
    private registrationFeeTokenService: RegistrationFeeTokenService,
    private santhy: DomSanitizer
  ) {
    this.redirectUrl = null;
    this.shoppingCartService.getItemsLength()
      .subscribe(res => {
        if (res != null) {
          this.getCartItems();
          this.lengthItems = res.length;
          if (this.lengthItems == 0) {
            $(".title-wrapper").prop('disabled', true);
          }
        }
      });
    this.dialogBillFormValidator = billDialogFn.group({
      'billDialog': ['', Validators.compose([Validators.required, dialogValidator])],
    });
    this.eZcashFormValidator = eZcashFn.group({
      'ezCash': ['', Validators.compose([Validators.required, dialogEtisalatHutchValidator])],
    });
    this.mCashFormValidator = mCashFn.group({
      'mCash': ['', Validators.compose([Validators.required, mobitelValidator])],
    });
    this.sampathVisaFormValidator = sampathVisaCashFn.group({
      'cardHolderName': ['', Validators.compose([Validators.required, emptyField])],
      'cardNo': ['', Validators.compose([Validators.required, emptyField, cardNumber])],
      'cardSecureId': ['', Validators.compose([Validators.required, cvv])],
      'cardExpiry': ['', Validators.compose([Validators.required, cardExpireDate])],
      'paymentAmount': ['', Validators.compose([Validators.required])],
      'csrfToken': ['', Validators.compose([Validators.required])]
    });
    this.lankaBellFormValidator = lankaBell.group({
      'lankaBell': ['', Validators.compose([Validators.required, lankaBellvalidator])],
    });
    this.shoppingCartService.isLoadPage(true);
    // temp redirection
    // this.rederectUrl('grade5://grade5.lk/payment/5a681abe8a728241cf8cc828?papers=true');
  }


  accordingHide(item) {
    Object.keys(this.paymentMethods).map(pm => {
      return item != pm ? this.paymentMethods[pm] = false : this.paymentMethods[item] = !this.paymentMethods[item];
    });

  }

  getTrustedUrl(url){
    return this.santhy.bypassSecurityTrustUrl(url);
  }

  billDialogPayment() {
    this.apiRequstWaiter = false;
    let transactionCode = this.registrationFeeService.getRegistrationTokenForFee();
    this.generatePaymentCode(ApiEndpoints.paymentMethodsDialog, (error, paymentId) => {
      this.httpClientService.authPaymentPost(ApiEndpoints.ezcashSubscribe, { invoiceId: this.paymentId, mobile: this.dialogBillFormValidator.controls['billDialog'].value, [ApiEndpoints.transactionCode]: transactionCode }).subscribe(res => {
        // this.httpClientService.authPost(ApiEndpoints.ezcashSubscribe, { invoiceId: this.paymentId, mobile: this.mobileNumber }).subscribe(res => {
        this.pincode = res.data.serverRef;
        this.apiRequstWaiter = true
        let that = this;
        swal({
          title: that.translateService.instant('ENTER_PIN_CODE'),
          text: that.translateService.instant('ENTER_PIN_CODE_DES'),
          input: 'text',
          showCancelButton: true,
          confirmButtonText: that.translateService.instant('BTN_CONFIRM'),
          inputPlaceholder: 'PIN',
          showLoaderOnConfirm: true,
          cancelButtonText: that.translateService.instant('BTN_SKIP'),
          customClass: 'pin-input',
          preConfirm: function (pin) {
            return new Promise(function (resolve, reject) {
              if (pin) {
                that.httpClientService.authPaymentPost(ApiEndpoints.ezcashSubmitpin, { invoiceId: that.paymentId, pin: pin, serverRef: that.pincode, mobile: that.dialogBillFormValidator.controls['billDialog'].value, [ApiEndpoints.transactionCode]: transactionCode, [ApiEndpoints.isRegistrationFee]: that.registrationFeeAvailable }).subscribe(res => {
                  // that.httpClientService.authPost(ApiEndpoints.ezcashSubmitpin, { invoiceId: that.paymentId, pin: pin, serverRef: that.pincode, mobile: that.mobileNumber }).subscribe(res => {
                  // that.isValidpaymentCode ? that.successPopupModal(res.redirectUrl) : 
                  // that.successPopupModal(res.redirectUrl);
                  that.rederectUrl(res.redirectUrl);
                  //that.router.navigate[res.redirectUrl];
                  that.apiRequstWaiter = false;
                  resolve();
                }, error => {
                  let e = error.json();
                  let message;
                  switch (e.description) {
                    case 'Wrong Pin':
                    case 'Wrong PIN':
                      message = that.translateService.instant('TRY_AGAIN_PIN_CODE');
                      break;
                    case 'User has insufficient credit for transaction':
                      message = that.translateService.instant('NOT_ENOUGH_BALANCE');
                      break;
                    default:
                      message = that.translateService.instant('TRY_AGAIN_ADDTOBILL')
                      break;
                  }
                  swal({
                    title: 'සාර්ථක නැත',
                    text: message,
                    type: 'error',
                    confirmButtonText: 'නැවත උත්සහ කරන්න'
                  });
                });
              } else {
                reject(that.translateService.instant('ENTER_PIN_CODE'));
              }
            })
          },
          allowOutsideClick: false
        }).then(function (pin) {
          that.apiRequstWaiter = true;
        }, function (dismiss) {
          if (dismiss === 'cancel') {
            that.apiRequstWaiter = true;
          }
        }).catch((e) => {
          that.apiRequstWaiter = true;
        })
      }, error => {
        this.ErrorManagerService.setError(error);
        if (error && error.json().code && error && error.json().code == 4010) {
          // this.router.navigate([BasicRoutes.checkout]);
          this.redirectToAnotherPage();
        }
      });
    });
  }

  eZcashPayment() {
    this.apiRequstWaiter = false;
    let transactionCode = this.registrationFeeService.getRegistrationTokenForFee();
    this.generatePaymentCode(ApiEndpoints.paymentMethodsEzcash, (error, paymentId) => {
      this.httpClientService.authPostWithSetIdForPayment(ApiEndpoints.paymentezCash, {
        [ApiEndpoints.invoiceId]: paymentId,
        [ApiEndpoints.mobile]: this.eZcashFormValidator.controls['ezCash'].value,
        [ApiEndpoints.transactionCode]: transactionCode,
        [ApiEndpoints.isRegistrationFee]: this.registrationFeeAvailable,
        // [ApiEndpoints.price]: this.paperSet.price,
      }, this.cookieManagerService.getCookie(CookieNames.paperSetKey, false)).subscribe(response => {
        if (response.redirectUrl) {
          // this.isValidpaymentCode ? this.successPopupModal(response.redirectUrl) : 
          this.rederectUrl(response.redirectUrl);
        }
        this.apiRequstWaiter = true;
      }, error => {
        this.ErrorManagerService.setError(error);
        this.errorText = this.translateService.instant(error && error.json().code ? ErrorText[error.json().code] : this.errorMessage);
        this.apiRequstWaiter = true;
        if (error && error.json().code && error && error.json().code == 4010) {
          // this.router.navigate([BasicRoutes.checkout]);
          this.redirectToAnotherPage();
        }
      });
    });
  }

  mCashPayment() {
    this.apiRequstWaiter = false;
    let transactionCode = this.registrationFeeService.getRegistrationTokenForFee();
    this.generatePaymentCode(ApiEndpoints.paymentMethodsMcash, (error, paymentId) => {
      this.httpClientService.authPostWithSetIdForPayment(ApiEndpoints.paymentmCash, {
        [ApiEndpoints.invoiceId]: paymentId,
        [ApiEndpoints.transactionCode]: transactionCode,
        [ApiEndpoints.isRegistrationFee]: this.registrationFeeAvailable,
        // [ApiEndpoints.mobile]: this.mobileNumber,//this.mCashFormValidator.controls['mCash'].value,
        [ApiEndpoints.mobile]: this.mCashFormValidator.controls['mCash'].value,
      }, this.cookieManagerService.getCookie(CookieNames.paperSetKey, false)).subscribe(response => {
        if (response.redirectUrl) {
          // this.isValidpaymentCode ? this.successPopupModal(response.redirectUrl) : 
          this.rederectUrl(response.redirectUrl);
          //this.router.navigate[response.redirectUrl];
        }
        this.apiRequstWaiter = true;
        window.clearImmediate;
        window.location.href = response.url;
      }, error => {
        this.ErrorManagerService.setError(error);
        this.errorText = this.translateService.instant(error && error.json().code ? ErrorText[error.json().code] : this.errorMessage);
        if (error && error.json().code && error && error.json().code == 4010) {
          // this.router.navigate([BasicRoutes.checkout]);
          this.redirectToAnotherPage();
        }
        this.apiRequstWaiter = true;
      });
    });
  }

  getVisaSampath() {

    let transactionCode = this.registrationFeeService.getRegistrationTokenForFee();
    this.generatePaymentCode(ApiEndpoints.paymentMethodsSampath, (error, paymentId) => {
      this.apiRequstWaiter = false;
      this.httpClientService.authPostWithSetIdForPayment(ApiEndpoints.sampathVisaToken, {
        [ApiEndpoints.invoiceId]: paymentId,
        [ApiEndpoints.transactionCode]: transactionCode,
        [ApiEndpoints.isRegistrationFee]: this.registrationFeeAvailable,
        // [ApiEndpoints.price]: this.paperSet.price,
      }, this.cookieManagerService.getCookie(CookieNames.paperSetKey, false)).subscribe((response: any) => {
        if (response) {
          // this.creditCard.csrfToken = response.csrfToken;
          // this.creditCard.paymentAmount = this.paperSet.price;
          window.location.href = response.paymentPageUrl;
        }
        // this.apiRequstWaiter = true;
      }, error => {
        this.ErrorManagerService.setError(error);
        this.errorText = this.translateService.instant(error && error.json().code ? ErrorText[error.json().code] : this.errorMessage);
        this.apiRequstWaiter = true;
      });
    });
  }

  sendSampathPayment(creditCard) {
    let transactionCode = this.registrationFeeService.getRegistrationTokenForFee();
    this.generatePaymentCode(ApiEndpoints.paymentMethodsSampath, (error, paymentId) => {
      this.apiRequstWaiter = false;
      this.httpClientService.authPostWithSetIdForPayment(ApiEndpoints.sampathVisaPayment, { creditCard, [ApiEndpoints.transactionCode]: transactionCode, [ApiEndpoints.isRegistrationFee]: this.registrationFeeAvailable },
        this.cookieManagerService.getCookie(CookieNames.paperSetKey, false)).subscribe((response: any) => {
          if (response.url) {
            window.location.href = response.url;
          }
          this.apiRequstWaiter = true;
        }, error => {
          this.apiRequstWaiter = true;
        });
    });
  }

  getVishwaSampath() {
    let transactionCode = this.registrationFeeService.getRegistrationTokenForFee();
    this.generatePaymentCode(ApiEndpoints.paymentMethodsSampath, (error, paymetid) => {
      this.apiRequstWaiter = false;
      this.httpClientService.authPaymentPost(ApiEndpoints.sampathVishwaPayment, { invoiceId: paymetid, [ApiEndpoints.transactionCode]: transactionCode, [ApiEndpoints.isRegistrationFee]: this.registrationFeeAvailable }).subscribe(res => {
        if (res) {
          window.location.href = res.url;
        }
      }, error => {
        this.apiRequstWaiter = true;
        this.ErrorManagerService.setError(error);
      });
    });
  }

  /**
   * Generate Payment Code
   */
  generatePaymentCode(paymentMethods, callback) {
    let transactionToken = this.registrationFeeService.getRegistrationTokenForFee();

    this.toCheckingArray = [];
    if (!this.isRegistration) {
      this.ItemsCheckout.forEach(item => { // need to check with item
        this.toCheckingArray.push(item.id);
      });
    }

    this.httpClientService.authPostWithSetId(ApiEndpoints.paymentReferenceCode, { [ApiEndpoints.paperSetIds]: this.toCheckingArray, [ApiEndpoints.paymentMethodsProvidor]: paymentMethods, [ApiEndpoints.paymentcode]: this.access_token, [ApiEndpoints.isRegistrationFee]: this.registrationFeeAvailable, [ApiEndpoints.transactionCode]: transactionToken }, null).subscribe(response => {
      this.paymentId = response.invoiceId;
      callback(null, this.paymentId);
    }, error => {
      this.ErrorManagerService.setError(error);
      this.errorText = this.translateService.instant(error && error.json().code ? ErrorText[error.json().code] : this.errorMessage);
      if (error && error.json().code && error && error.json().code == 4010) {
        // this.router.navigate([BasicRoutes.checkout]);
        this.redirectToAnotherPage();
      }
      callback(this.errorText);
    });

    // this.httpClientService.authPostWithSetId(ApiEndpoints.paymentReferenceCode, {
    // }, 
    // this.cookieManagerService.getCookie('paperSetKey', false)).subscribe(response => {
    //   this.paymentId = response.invoiceId;
    // }, error => {
    //   this.ErrorManagerService.setError(error);
    //   this.errorText = this.translateService.instant(error && error.json().code ? ErrorText[error.json().code] : this.errorMessage);
    // });
  }

  getAvilablePaymentTypes() {
    this.httpClientService.get(ApiEndpoints.paymentMethods).subscribe(response => {
      if (response) {
        response = response.map(element => {
          return Gtype[element.gtype] ? Gtype[element.gtype][element.isActive] : '';
        });
        var f = {};
        response.forEach((value, key) => {
          var t = Object.keys(value);
          f[t[0]] = value[t[0]];
        });
        this.paymentType = f;
      }

    }, error => {
      this.ErrorManagerService.setError(error);
    });
  }

  getUserData() {
    let trans = this.translateService;
    this.httpClientService.authGet(ApiEndpoints.getUserById, null).subscribe(response => {
      this.user = response.user;
      this.mobile = this.user.setting.mobile;
      this.separateMobileNumbers();
    }, error => {
      this.ErrorManagerService.setError(error);
    });
  }
  public myValue: boolean = false;


  ngOnInit() {
    this.getRegistrationDetails((callback) => {

      this.getOfferDetails((error, callbackId) => {
        this.getAvilablePaymentTypes();
        // this.getOfferDetails();// get the descousnt detials

        this.errorMessage = this.translateService.instant('PAYMENT_COMMON_ERROR');
        this.route.params.forEach((params: Params) => {
          if ((params['paymentcode'] || false)) {
            this.access_token = params['paymentcode'];
          } else if ((params['token'] || false)) {
            this.access_token = params['token'];
          }
          //this.cookieManagerService.setCookie(CookieNames.paperSetKey, this.setid, false, 1);
          // kaushalya 2017-10-17 get the cart details

          if (this.access_token != null) {
            this.customObserverService.setPaymentCode(true); this.customObserverService.setRegistrationFee(true);
            this.httpClientService.authGet(ApiEndpoints.replaceParms(ApiEndpoints.getPaymentMobileAutenticate,
              {
                [ApiEndpoints.paymentcode]: this.access_token
              }), this.cookieManagerService.getCookie(CookieNames.paperSetKey, false)).subscribe(response => {
                this.cookieManagerService.deleteAll();
                this.localStorageService.clearAll();
                if (response.user.image) {
                  this.imageProfile = response.user.image;
                } else {
                  this.imageProfile = '/assets/img/default-avatar.svg';
                }
                let userDetails = response.user;
                delete userDetails.image;
                this.cookieManagerService.setCookie(CookieNames.userobj, JSON.stringify(userDetails));
                this.cookieManagerService.setCookie(CookieNames.loginKey, response.token, false);

                this.localStorageService.set(CookieNames.userImage, this.imageProfile);
                if (response.user.firstname) {
                  this.customObserverService.setName(response.user.firstname);
                } else {
                  this.customObserverService.setName(response.user.mobile);
                }
                this.customObserverService.setData(this.imageProfile);
                this.isValidpaymentCode = response;
                this.userId = response.user._id;
                if (!this.isRegistration) {
                  this.getPaperSets(); // get the paper set
                }
                this.addToLocalStorage(response.paperSets);

              }, error => {
                let err = error.json();
                this.access_token = null;
                let that = this;
                swal({
                  title: this.translateService.instant('PAYMENT_NOT_SUCCESS_HEAD'),
                  html: this.translateService.instant('PAYMENT_NOT_SUCCESS_BODY'),
                  confirmButtonText: this.translateService.instant('PAYMENT_NOT_SUCCESS_BTN'),
                  type: 'error'
                }).then(() => {
                  window.open('grade5://grade5.lk');
                }, function (dismiss) {
                  window.open('grade5://grade5.lk');
                });
              });
          }
          else {
            this.getUser(); // get user
            if (!this.isRegistration) {
              this.getPaperSets(); // get the paper set
              this.getcartdetails(); // get cart details
            }

          }


        });
      });
      window.scrollTo(0, 0);
      this.customObserverService.setPaymentFlowIcon(PaymentSteps.paymentOptions);
    });
    // Comment temporary for second phase implementation

    // this.getPaperSetDetails();
    // this.generatePaymentCode();
    // this.getUserData();
    // document.body.scrollTop = 0;
  }

  addToLocalStorage(paperSets) {
    this.shoppingCartService.clearAll();
    paperSets.forEach(ppr => {
      let paper = new PaperSet(ppr);
      this.shoppingCartService.storeItemsCheckout(paper);
    });
    this.getcartdetails();

  }

  getPaperSetDetails() {
    this.paperSet = new PaperSet(JSON.parse(JSON.stringify(this.cookieManagerService.getCookie(CookieNames.paperSet, true)), function (key, value) {
      return value;
    }));
  }

  rederectUrl(url) {
    if(url.startsWith('grade5://')){
      this.redirectUrl = url;
      this.isMobileRedirection = true;
      // window.open(url, '_system', 'location=no,clearsessioncache=no,clearcache=no');
    }else{
      window.location.href = url;
    }
  }

  paymentError(text) {
    if (!text && this.apiRequstWaiter) {
      this.errorText = this.translateService.instant('ADD_YOUR_MOBILE_NUMBER');
      return;
    }
    this.errorText = text;
  }

  resetForms() {
    this.dialogBillFormValidator.reset();
    this.eZcashFormValidator.reset();
    this.mCashFormValidator.reset();
    this.errorText = '';
    this.apiRequstWaiter = true;
  }

  separateMobileNumbers() {
    this.mobile.forEach(num => {
      if (mobileNumberValidator(num.data, 1)) {
        this.mobitelNumberList.push(num.data);
      }
    });
    this.mobile.forEach(num => {
      if (mobileNumberValidator(num.data, 2)) {
        this.dialoglNumberList.push(num.data);
      }
    });
  }

  setCardType(number) {
    return getCardType(number);
  }

  /**
   * kaushlya
   * 2017-10-17
   * getcartdetails
   */
  getcartdetails() {
    // get going to buy paper set
    this.ItemsCheckout = this.shoppingCartService.allStorage();
    // get total price
    let totalPriceAmount = this.shoppingCartService.returnTotalPrice();
    let discountPriceAmount = totalPriceAmount * this.discountPrice / 100
    this.totalPrice = totalPriceAmount - discountPriceAmount;
    //if registration fee available
    if (this.registrationFeeAvailable) {
      this.totalPrice = this.totalPrice + this.registrationFee;
    }
    this.getToBuyPaperset();

    if (this.ItemsCheckout.length == 0 && this.access_token == null) {
      //this.router.navigate(['home/exams/']); // if the cart is empty redirect to the home page
    }
  }

  /**
   * kauhslya
   * 2017-10-17
   * load the confermation alert for removiing
   */
  removeItemModalload(type, itemId) {
    let items = this.shoppingCartService.allStorage();
    if (type && items.length == 1) {
      this.removeItemId = itemId;
      $('#deleteConfermation-model').modal('show');
    } else {
      $('#deleteConfermation-model').modal('hide');
      this.shoppingCartService.removeItemsCheckout((itemId == -1) ? this.removeItemId : itemId);
      this.getcartdetails();
      this.removeItemId = 0;
    }
  }

  getPaperSets() {
    this.paperSets = [];
    this.httpClientService.authGet(ApiEndpoints.replaceParms(ApiEndpoints.getPendingPapersToBuy, { [ApiEndpoints.students]: this.userId }), null).subscribe(
      res => {
        res.papersets.forEach(set => {
          this.paperSets.push(new PaperSet(set));
        });
        this.getToBuyPaperset();
      }, e => {

      });
  }
  /**
    * kauhsalya
    * 2017-0-11
    * get user papers according to the user status
    */
  getUser() {
    let userObj = this.cookieManagerService.getCookie(CookieNames.userobj, false);
    this.user = userObj ? JSON.parse(userObj.toString()) : null;
    if (this.user) {
      this.userId = this.user._id;
    }
  }
  getCartItems() {
    this.shoppingCartService.itemsCheckout.subscribe((response) => {
      this.ItemsCheckout = response;
      this.totalPrice = this.shoppingCartService.returnTotalPrice();
    });
  }

  /**
   * kaushalya
   * 2017-10-17
   * get tobuy paper set
   */
  getToBuyPaperset() {
    let i = 0;
    this.toBuyPaperSets = [];
    this.toBuyCheckingArray = [];

    this.ItemsCheckout.forEach(item => {
      this.toBuyCheckingArray.push(item.id);
    });

    this.paperSets.forEach(paperSet => {
      if (i < 3) {
        if (this.toBuyCheckingArray.indexOf(paperSet._id) == -1) {
          this.toBuyPaperSets.push(paperSet);
          this.toBuyCheckingArray.push(paperSet._id);
          i++;
        }
      } else {
        return;
      }
    });
  }

  /**
   * kaushalya
   * 2017-10-17
   * add new paperset tocart
   */
  addItemModalload(toBuyPaper) {
    this.shoppingCartService.storeItemsCheckout(toBuyPaper);
    this.getcartdetails();
  }

  /**
   * kauhsalya
   * 2017-10-17
   * back function
   */
  backFunction() {
    this.router.navigate(['home/pay/billing-info/']);
    this.customObserverService.setPaymentFlowIcon(PaymentSteps.billingDetails);

  }

  /**
   * kauhsalya
   * 2017-10-17
   * back function
   */
  getmorePapers() {
    this.router.navigate([BasicRoutes.clientExams]);
    this.customObserverService.setPaymentFlowIcon(0);

  }

  /**
   * kauhsalya
   * 2017-11-13
   * get offer details
   */
  getOfferDetails(callback) {
    this.httpClientService.get(ApiEndpoints.offerImage).subscribe(response => {
      if (Object.keys(response).length != 0) {
        if (response && response.isDiscountOffer && !response.isAnnouncement) {
          this.discountPrice = response.discountRate
        }
      }
      callback(this.discountPrice);
    });
  }

  /**
   * get the registration details
   * 2017-01-17
   */
  getRegistrationDetails(callback) {
    let isAvailable = false;
    let isMobile = false;
    if (this.registrationFeeService.getRegistrationTokenForFee()) { //web user 
      isAvailable = true;

    } else if ((this.cookieManagerService.getCookie(CookieNames.registrationFee, false) || false)) {
      isAvailable = true;
      this.registrationFeeTokenService.setRegistrationToken(this.cookieManagerService.getCookie(CookieNames.registrationToken, false));
      this.registrationFeeService.setRegistrationTokenForFee(this.cookieManagerService.getCookie(CookieNames.registrationCode, false));
      this.route.params.forEach((params: Params) => {
        if ((params['token'] || false)) {
          isMobile = true;
          this.isMobile = true;
        }
      });
    }
    else {// mobile user
      this.route.params.forEach((params: Params) => {
        if ((params['token'] || false)) {
          isAvailable = true;
          isMobile = true;
          this.isMobile = true;
          this.registrationFeeService.setRegistrationTokenForFee(params['token']);
        } if ((params['code'] || false)) {
          isAvailable = true;
          isMobile = true;
          this.isMobile = true;
          this.registrationFeeService.setRegistrationTokenForFee(params['code']);
        }
      });
    }

    if (isAvailable) {
      this.httpClientService.authGet(ApiEndpoints.replaceParms(ApiEndpoints.getRegistrationFeeGForUser, { [ApiEndpoints.registrationToken]: this.registrationFeeService.getRegistrationTokenForFee() }), null).subscribe(
        res => {
          this.registrationFee = res['registerFee'];
          if (isMobile && res['token'] != null) {
            this.registrationFeeTokenService.setRegistrationToken(res['token']);
            this.cookieManagerService.setCookie(CookieNames.registrationToken, this.registrationFeeTokenService.getRegistrationToken());
          }
          if (this.registrationFee) {
            this.registrationFeeAvailable = true;
            callback(this.registrationFeeAvailable);
          } else {
            callback(this.registrationFeeAvailable);
          }
        }, e => {
          this.registrationFeeAvailable = false;
          callback(this.registrationFeeAvailable);
        });
    } else {
      callback(this.registrationFeeAvailable);
    }
  }

  successPopupModal(url) {
    let _global = this;
    swal({
      title: this.translateService.instant('SUCCESS_BUY_PAPER'),
      text: this.translateService.instant('SUCCESS_BUY_PAPER_TEXT'),
      confirmButtonText: this.translateService.instant('SW_MESSAGE1'),
    }).then(() => {
      _global.rederectUrl(url);
    }, function (dismiss) {
      _global.rederectUrl(url);
    });
  }

  redirectToAnotherPage(){
    if(this.isMobile){
      this.isMobileRedirection = true;
      this.redirectUrl = ApiEndpoints.MOBILE_APP_URL;
    }else{
      this.router.navigate([BasicRoutes.checkout]);
    }
  }

}




// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/payment/components/payment.component.ts